import React from "react";

const Almacen = () => {
  return <div>Estamos en el almacen</div>;
};

export default Almacen;
